import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import PickersDay, { pickersDayClasses } from '@mui/lab/PickersDay';
import StaticDatePicker from '@mui/lab/StaticDatePicker';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box'; // import { DateTime } from 'luxon'

import { format } from 'date-fns';
import TAGTypography from '../TAGTypography/TAGTypography';
import { disableSunday } from './TAGPicker.type';
import { transformedColor } from '../../../constants/themehelper';

var TAGDateCalendar = function TAGDateCalendar(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'secondary' : _ref$color,
      displayStaticWrapperAs = _ref.displayStaticWrapperAs,
      onChange = _ref.onChange,
      tempValue = _ref.tempValue;

  var DatePickerToolBar = function DatePickerToolBar(props) {
    return React.createElement(Box, {
      sx: {
        alignItems: 'center',
        padding: '12px 24px',
        // background: 'backgrounds.dark',
        color: 'text.light',
        backgroundColor: transformedColor(color)
      }
    }, props.date && React.createElement(React.Fragment, null, React.createElement(TAGTypography, {
      variant: "bodyMediumBook",
      color: "text.light"
    }, "".concat(format(new Date(props.date), 'yyyy'))), React.createElement(TAGTypography, {
      variant: "h3",
      color: "text.light"
    }, "".concat(format(new Date(props.date), 'EEE, dd MMM')))));
  };

  var renderDayPickerDay = function renderDayPickerDay(_date, _selectedDates, pickersDayProps) {
    return React.createElement(PickersDay, _objectSpread(_objectSpread({}, pickersDayProps), {}, {
      sx: _defineProperty({}, "&&.".concat(pickersDayClasses.selected), {
        backgroundColor: transformedColor(color)
      })
    }));
  };

  return React.createElement(Box, {
    sx: {
      '& > div > div, & > div > div > div, & .MuiCalendarPicker-root': {
        boxSizing: 'border-box'
      },
      '& > div > div, & > div > div > div': {
        width: '100%'
      },
      '& .MuiCalendarPicker-root': {
        maxWidth: '370px',
        width: '100%',
        padding: '0px 20px' // border: '2px solid red',

      },
      '& .MuiTypography-caption': {
        width: '100%',
        margin: 0
      },
      '& .PrivatePickersSlideTransition-root': {
        minHeight: 40 * 6
      },
      '& .PrivatePickersSlideTransition-root [role="row"]': {
        margin: 0
      },
      '& .MuiPickersDay-dayWithMargin': {
        margin: 0
      },
      '& .MuiPickersDay-root': {
        width: '100%',
        aspectRatio: '1/1',
        height: 'auto'
      }
    }
  }, React.createElement(StaticDatePicker, {
    renderDay: renderDayPickerDay,
    ToolbarComponent: function ToolbarComponent(props) {
      return React.createElement(DatePickerToolBar, _objectSpread({}, props));
    },
    displayStaticWrapperAs: displayStaticWrapperAs,
    shouldDisableDate: disableSunday,
    value: tempValue,
    toolbarFormat: "EEE, d MMM",
    onChange: onChange,
    renderInput: function renderInput(params) {
      return React.createElement(TextField, _objectSpread({}, params));
    }
  }));
};

export default TAGDateCalendar;